import { InjectionToken } from '@angular/core';

export interface HubSpotConfig {
  portalId: string;
  formId: string;
  region: string;
}

export const HUBSPOT_CONFIG = new InjectionToken<HubSpotConfig>('HUBSPOT_CONFIG');
